export default __webpack_public_path__ + "static/media/Blade's Gloves of Charred Earth.8d4bdad2.jpg";